/**
 * React Query hooks for the Reward Caps screen. The caps + monitor auto-refresh
 * (30s) so the farming signal (users at the daily cap) stays current while an
 * admin watches; the mutation invalidates the query so a save reflects at once.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchRewardCaps,
  updateRewardCaps,
  RewardLimits
} from '@/api/rewardCaps';

export function useRewardCaps() {
  return useQuery({
    queryKey: ['rewardCaps'],
    queryFn: fetchRewardCaps,
    refetchInterval: 30_000
  });
}

export function useUpdateRewardCaps() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Partial<RewardLimits>) => updateRewardCaps(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['rewardCaps'] })
  });
}
